module.exports = __webpack_public_path__ + "static/media/action-ref.d3e3de1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/action-ref.png
// module id = 78
// module chunks = 0